import { type ContentComponent, type InspirationContent } from '../../../../../types/construct.types';
import {
	type HomeTipsInspirationProps,
	HomeTipsInspiration
} from '../../../../home-components/home-tips-inspiration/home-tips-inspiration.component';

export const transformTipsInspirationContent = (content: InspirationContent): HomeTipsInspirationProps => ({
	title: content.fields.main.fields.title ?? '',
	description: content.fields.main.fields.description ?? '',
	callToAction: {
		__typename: 'TrackingLink',
		name: content.fields.main.fields.buttonText ?? '',
		url: content.fields.main.fields.link.linkUrl ?? '',
		tracking: content.fields.main.fields.link.trackingCode ?? ''
	},
	content: content.fields.carousel.items
});

// TODO: EFDC-37544 - Refactor HomeTipsInspiration to consume construct types and remove the transformer
export const HomeTipsInspirationHandler: ContentComponent<InspirationContent> = ({ content }) => {
	return <HomeTipsInspiration {...transformTipsInspirationContent(content)} />;
};
